<template>
    <div class="mb-3">
        <b-row>
            <b-col sm="12" md="10">
                <div class="d-flex align-items-start fz-24 fw-500 w-100">
                    <span>{{ $t(title) }}</span>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <popupInfo :name="type" v-if="showPopup"></popupInfo>
                    </span>
                </div>
            </b-col>
            <b-col v-if="status == 1 || status == 0" sm="12" md="2" class="text-right">
                <span
                    :class="'text-' + (status == 1 ? 'verified' : 'pending')">{{ status == 1 ? $t('Verified') : $t('Pending') }}</span>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import popupInfo from "@/components/popupInfo";

export default {
    name: 'kyc-title',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            showPopup: false
        }
    },
    props: ['title', 'type', 'status'],
    components: {
        popupInfo
    },
    methods: {
        togglePopup(name) {
            this.showPopup = !this.showPopup;
        }
    }
};
</script>
